
import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import Master from "screen/Master";
import styles from "../AddInvoiceComponent.module.scss";
import TaxAmountTable from "components/Tables/TaxAmountTable";
import {getRequest} from '../../services/axiosBaseClient'

export default function AddInvoiceView(props) {

  const [data, setBatteryData] = useState({});
  const batteryInfo = props.id

  const getBatteryInformation = useCallback(async(id)=>{
   await getRequest("bss/getBatteryInformation?batteryId="+id).then((res)=>{
    if(res && res.data){
      console.log(res?.data)
      setBatteryData(res?.data)
      console.log(data);
    }
  })
},[]);



useEffect(()=>{
  getBatteryInformation(batteryInfo);
},[]);



  return (
    <>
      <div className={cn(styles.flex_item1)}>
          <div className={cn(styles.flex1)}>
            <div className={cn(styles.group, styles.group_layout)}>
              <div className={cn(styles.flex3, styles.flex3_layout)}>
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Pack ID"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.packId}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex3_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Pack Voltage"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.packVoltage}
                      </div>
                    </div>
                  </div>
                </div>
                {/* ---- */}
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Pack FW Version"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex3_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.packFWVersion}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Charge Voltage"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.chargerVoltage}
                      </div>
                    </div>
                  </div>
                </div>
                {/* ---- */}
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Current State"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex3_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                         {data.currentState ? data?.currentState : data?.state}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Discharge Voltage"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.dischargeVoltage}
                      </div>
                    </div>
                  </div>
                </div>
                {/* -- */}
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Status"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex3_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.state}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Pack Current"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.packCurrent}
                      </div>
                    </div>
                  </div>
                </div>
                {/* --- */}
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Lat/Long."}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex3_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                      {data.latitude == "N/A" ? data.latitude :
                        data.latitude+ "/" + data.longitude
                      }
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Charge Current"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.chargeCurrent}
                      </div>
                    </div>
                  </div>
                </div>
                {/* -- */}
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Timestamp"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex3_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {Date(data.timestamp)}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Discharge Current"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.dischargeCurrent}
                      </div>
                    </div>
                  </div>
                </div>
                {/* -- */}
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"SOC (%)"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.soc}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"PCB Temperature"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.pcbTemperature}
                      </div>
                    </div>
                  </div>
                </div>
                {/* -- */}
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"SOH (%)"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.soh}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"IC Temperature"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.icTemperature}
                      </div>
                    </div>
                  </div>
                </div>
                {/* -- */}
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"SOP"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.sop}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Units consumed in charging"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.unitsConsumed}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={cn(styles.flex3, styles.flex3_layout)}>
              {/* <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
              {"Cell Voltage"}
            </h2> */}
            <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
                    {"Cell Voltage"}
                    </h2>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />

                  <div className={cn(styles.flex3_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
                    {"Temperature"}
                    </h2>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                </div>
                {/* -------- */}
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Cell Voltage 1"}
                      </div> 
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.cellVoltage1}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex3_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Temp 1"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.temp1}
                      </div>
                    </div>
                  </div>
                </div>
                {/* ---- */}
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Cell Voltage 2"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex3_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.cellVoltage2}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Temp 2"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.temp2}
                      </div>
                    </div>
                  </div>
                </div>
                {/* ---- */}
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Cell Voltage 3"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex3_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.cellVoltage3}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Temp 3"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.temp3}
                      </div>
                    </div>
                  </div>
                </div>
                {/* -- */}
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Cell Voltage 4"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex3_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.cellVoltage4}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Temp 4"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.temp4}
                      </div>
                    </div>
                  </div>
                </div>
                {/* --- */}
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Cell Voltage 5"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex3_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.cellVoltage5}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Temp 5"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.temp4}
                      </div>
                    </div>
                  </div>
                </div>
                {/* -- */}
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Cell Voltage 6"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex3_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.cellVoltage6}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Temp 6"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.temp4}
                      </div>
                    </div>
                  </div>
                </div>
                {/* -- */}
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Cell Voltage 7"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.cellVoltage5}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                   
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                   
                    </div>
                  </div>
                </div>
                {/* -- */}
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Cell Voltage 8"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.cellVoltage1}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                   
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                   
                    </div>
                  </div>
                </div>
                {/* -- */}
                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Cell Voltage 9"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                        className={cn(
                          styles.text4_body,
                          styles.text4_body_layout
                        )}
                      >
                        {data.cellVoltage2}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                    </div>
                  </div>
                </div>
              </div>
            <div className={cn(styles.flex4, styles.flex4_layout)}></div>
          </div>
          </div>
        <div>
    </div>
</div>  
    </>
  );
}

